export default {
  tableLoader(state, value) {
    return (state.tableLoading = value);
  },

  employees(state, employees) {
    return (state.employees = employees);
  },

  totalEmployees(state, total) {
    return (state.totalEmployees = total);
  },

  currentPage(state, value) {
    return (state.currentPage = value);
  },

  perPage(state, value) {
    return (state.perPage = value);
  },

  employeeTypesCurrentPage(state, value) {
    return (state.employeeTypesCurrentPage = value);
  },

  employeeTypesPerPage(state, value) {
    return (state.employeeTypesPerPage = value);
  },

  employeeGradesCurrentPage(state, value) {
    return (state.employeeGradesCurrentPage = value);
  },

  employeeGradesPerPage(state, value) {
    return (state.employeeGradesPerPage = value);
  },

  totalEmployeeTypes(state, value) {
    return (state.totalEmployeeTypes = value);
  },

  totalEmployeeGrades(state, value) {
    return (state.totalEmployeeGrades = value);
  },

  totalEmployeeDesignations(state, value) {
    return (state.totalEmployeeDesignations = value);
  },

  totalEmployeeCategories(state, value) {
    return (state.totalEmployeeCategories = value);
  },

  employeeCategoriesCurrentPage(state, value) {
    return (state.employeeCategoriesCurrentPage = value);
  },
  employeeCategoriesPerPage(state, value) {
    return (state.employeeCategoriesPerPage = value);
  },

  employeeDesignationsCurrentPage(state, value) {
    return (state.employeeDesignationsCurrentPage = value);
  },

  employeeDesignationsPerPage(state, value) {
    return (state.employeeDesignationsPerPage = value);
  },

  searchQuery(state, value) {
    return (state.searchQuery = value);
  },

  filterValue(state, value) {
    return (state.filterValue = value);
  },

  employeeTypes(state, types) {
    return (state.employeeTypes = types);
  },
  employeeGrades(state, grades) {
    return (state.employeeGrades = grades);
  },
  employeeCategories(state, categories) {
    return (state.employeeCategories = categories);
  },
  employeeDesignations(state, designations) {
    return (state.employeeDesignations = designations);
  },
  toggleUploadDialog(state, value) {
    return (state.showUploadDialog = value ? value : !state.showUploadDialog);
  },
  archivedEmployees(state, value) {
    return (state.archivedEmployees = value);
  },

  totalArchivedEmployees(state, value) {
    return (state.totalArchivedEmployees = value);
  },

  archiveEmployeeCurrentPage(state, value) {
    return (state.archiveEmployeeCurrentPage = value);
  },
  archiveEmployeePerPage(state, value) {
    return (state.archiveEmployeePerPage = value);
  },
};
